import ls from 'localstorage-slim';
import { Stats } from 'pixi-stats';
import type { Application } from 'pixi.js';
import { UPDATE_PRIORITY } from 'pixi.js';

type Styles = {
  [key: string]: string;
};

const offsets = {
  x: 50,
  y: 30,
};
const defaultScale = 0.5;
const defaultStyles: Styles = {
  position: 'fixed',
  left: `-${offsets.x}px`,
  bottom: `-${offsets.y}px`,
  opacity: '0.8',
  'user-select': ' none',
  scale: `${defaultScale}`,
  userSelect: 'none',
};

export class PixiStats {
  private stats: Stats;
  private element!: HTMLElement;

  constructor(pixi: Application) {
    this.stats = new Stats(pixi.renderer);

    pixi.ticker.add(this.stats.update, this.stats, UPDATE_PRIORITY.UTILITY);

    this.stats.showPanel(ls.get('stats-mode') ?? 0);

    const element = this.stats.domElement;

    if (!element) {
      console.error('Stats element not found');

      return;
    }

    this.element = element;

    this.element.addEventListener('pointerup', () => {
      setTimeout(() => {
        ls.set('stats-mode', this.stats.mode);
      }, 10);
    });

    this.setStyles(defaultStyles);
    this.element.style.zIndex = '1000';
  }

  setStyles(styles: Styles) {
    if (!this.element) {
      console.error('Stats element not found');

      return;
    }

    for (const style in styles) {
      this.element.style.setProperty(style, styles[style]);
    }
  }

  remove() {
    if (!this.element) {
      console.error('Stats element not found');

      return;
    }

    this.element.remove();
  }
}
